webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(29);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(23);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(12);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(15);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _About = __webpack_require__(13);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{
	  path: '/home',
	  component: _Home2.default
	}, {
	  path: '/about',
	  component: _About2.default
	}, {
	  path: '*',
	  component: _Home2.default
	}];
	var router = new _vueRouter2.default({
	  routes: routes
	});
	
	new _vue2.default({
	  router: router,
	  el: '#app',
	  template: '<App/>',
	  components: {
	    App: _App2.default
	  }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(16);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Footer = __webpack_require__(14);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    navbar: _Navbar2.default,
	    footersection: _Footer2.default
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _downloadjs = __webpack_require__(5);
	
	var _downloadjs2 = _interopRequireDefault(_downloadjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      index: 0,
	      images: [],
	      focused: true
	    };
	  },
	
	  methods: {
	    changeIndex: function changeIndex(val) {
	      var _this = this;
	
	      this.index = Math.max(0, Math.min(val, this.images.length - 1));
	      _vue2.default.nextTick(function () {
	        if (_this.$refs.current) {
	          _this.$refs.current[0].focus();
	        }
	      });
	    },
	    changeImages: function changeImages(evt) {
	      var files = evt.target.files;
	      var self = this;
	      self.images = [];
	
	      var _loop = function _loop() {
	        file = files[i];
	
	        var name = file.name;
	        if (files[i].type.substring(0, 5) === 'image') {
	          reader = new window.FileReader();
	
	          reader.onloadend = function (ev) {
	            if (ev.target.readyState === window.FileReader.DONE) {
	              self.images.push({
	                name: name,
	                content: ev.target.result,
	                annotation: ''
	              });
	            }
	          };
	          reader.readAsDataURL(files[i]);
	        }
	      };
	
	      for (var i = 0; i < files.length; i++) {
	        var file;
	        var reader;
	
	        _loop();
	      }
	      this.changeIndex(0);
	    },
	    getSummary: function getSummary() {
	      var content = this.images.map(function (im) {
	        return im.name + '\t' + im.annotation;
	      }).join('\n');
	      (0, _downloadjs2.default)(content, 'annotations.txt', 'text/csv');
	    }
	  }
	};

/***/ },
/* 5 */,
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(7)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(18)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(21)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7e50da6c"
	
	module.exports = __vue_exports__


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(20)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4dd1e8cc"
	
	module.exports = __vue_exports__


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(6)
	
	/* script */
	__vue_exports__ = __webpack_require__(4)
	
	/* template */
	var __vue_template__ = __webpack_require__(17)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1b279850"
	
	module.exports = __vue_exports__


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(19)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-26f7e67e"
	
	module.exports = __vue_exports__


/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Images Annotator")]), _c('h3', {
	    staticClass: "text-center"
	  }, [_vm._v("Label your images, get a summary spreadsheet")]), _c('label', {
	    staticClass: "btn btn-default btn-file center-block",
	    staticStyle: {
	      "width": "200px"
	    }
	  }, [_vm._v("Select some pictures"), _c('input', {
	    staticClass: "hidden file",
	    attrs: {
	      "type": "file",
	      "multiple": "1",
	      "name": "files"
	    },
	    on: {
	      "change": _vm.changeImages
	    }
	  })]), (_vm.images.length) ? _c('div', {
	    staticClass: "diaporama"
	  }, [_vm._l((_vm.images), function(image, i) {
	    return (i === _vm.index) ? _c('div', {
	      key: i
	    }, [_c('h4', {
	      staticClass: "text-center"
	    }, [_vm._v(_vm._s(i + 1) + "/" + _vm._s(_vm.images.length) + " : " + _vm._s(image.name))]), _c('div', {
	      staticClass: "images-div"
	    }, [_c('span', {
	      staticClass: "helper"
	    }), _c('img', {
	      attrs: {
	        "src": image.content
	      }
	    })]), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (image.annotation),
	        expression: "image.annotation"
	      }],
	      ref: 'current',
	      refInFor: true,
	      staticClass: "center-block",
	      attrs: {
	        "placeholder": "Type a comment"
	      },
	      domProps: {
	        "value": _vm._s(image.annotation)
	      },
	      on: {
	        "keydown": [function($event) {
	          if (_vm._k($event.keyCode, "enter", 13)) { return; }
	          _vm.changeIndex(_vm.index + 1)
	        }, function($event) {
	          if (_vm._k($event.keyCode, "space", 32)) { return; }
	          if (!$event.ctrlKey) { return; }
	          _vm.changeIndex(_vm.index - 1)
	        }],
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          image.annotation = $event.target.value
	        }
	      }
	    }), _vm._m(0, true)]) : _vm._e()
	  }), _c('div', {
	    staticClass: "btn btn-default center-block",
	    staticStyle: {
	      "width": "150px"
	    },
	    on: {
	      "click": _vm.getSummary
	    }
	  }, [_vm._v("Get summary")])], 2) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "infos"
	  }, [_vm._v("Press "), _c('b', [_vm._v("Enter")]), _vm._v(" for the next picture, "), _c('b', [_vm._v("Ctrl+Space")]), _vm._v(" for the previous picture")])
	}]}

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('navbar'), _c('div', {
	    staticClass: "container"
	  }, [_c('router-view')], 1), _c('footersection')], 1)
	},staticRenderFns: []}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('nav', {
	    staticClass: "navbar navbar-default navbar-static-top"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "navbar-collapse collapse",
	    attrs: {
	      "id": "navbar"
	    }
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav nav-pills"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "home"
	    }
	  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "about"
	    }
	  }, [_vm._v("About")])], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "navbar-header"
	  }, [_c('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#navbar",
	      "aria-expanded": "false",
	      "aria-controls": "navbar"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _c('span', {
	    staticClass: "icon-bar"
	  }), _c('span', {
	    staticClass: "icon-bar"
	  }), _c('span', {
	    staticClass: "icon-bar"
	  })]), _c('div', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(11)
	    }
	  })])])
	}]}

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', [_c('div', {
	    staticClass: "container"
	  }), _vm._v("© Edinburgh Genome Foundry, 2017")])
	}]}

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('h1', [_vm._v("About the images annotator")]), _c('p', [_vm._v("This app provides a simple way to label or comment a series of pictures .")]), _c('p', [_vm._v("It was developed at the Ediburgh Genome Foundry as a useful toy project for Vue.js")]), _c('p')])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.f16483ce8a52217398be.js